// src/Dashboard/pages/user/ArbitrageJudo/components/ArbitrageHero.jsx

import React from "react";
import {
  FaBalanceScale,
  FaBookOpen,
  FaFlagCheckered,
  FaQuestionCircle,
  FaShieldAlt,
} from "react-icons/fa";

export default function ArbitrageHero({
  activeView,
  onChangeView,
  sectionsCount = 0,
}) {
  return (
    <article className="overflow-hidden rounded-[30px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="relative overflow-hidden bg-slate-950 px-5 py-7 text-white sm:px-7">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(76,168,47,0.28),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(1,62,142,0.48),transparent_38%)]" />

        <div className="relative grid gap-6 lg:grid-cols-[minmax(0,1fr)_340px] lg:items-center">
          <div>
            <p className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-bold uppercase tracking-wide text-white/80 ring-1 ring-white/15">
              <FaBalanceScale className="text-[#4CA82F]" />
              Arbitrage Judo
            </p>

            <h1 className="mt-4 text-3xl font-bold tracking-tight sm:text-4xl">
              Comprendre les règles, les gestes et les décisions d’arbitrage
            </h1>

            <p className="mt-3 max-w-3xl text-sm leading-6 text-white/80 sm:text-base">
              Une aide rapide pour les judokas, enseignants, jeunes arbitres et
              commissaires sportifs : commandes, scores, pénalités, temps de
              combat et règles essentielles.
            </p>

            <div className="mt-5 flex flex-col gap-2 sm:flex-row">
              <button
                type="button"
                onClick={() => onChangeView("cours")}
                className={`inline-flex items-center justify-center gap-2 rounded-2xl px-5 py-3 text-sm font-bold transition ${
                  activeView === "cours"
                    ? "bg-white text-slate-950 shadow-lg"
                    : "bg-white/10 text-white ring-1 ring-white/20 hover:bg-white/15"
                }`}
              >
                <FaBookOpen />
                Voir les fiches
              </button>

              <button
                type="button"
                onClick={() => onChangeView("quiz")}
                className={`inline-flex items-center justify-center gap-2 rounded-2xl px-5 py-3 text-sm font-bold transition ${
                  activeView === "quiz"
                    ? "bg-[#4CA82F] text-white shadow-lg"
                    : "bg-white/10 text-white ring-1 ring-white/20 hover:bg-white/15"
                }`}
              >
                <FaQuestionCircle />
                Faire le QCM
              </button>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-3 lg:grid-cols-1">
            <div className="rounded-3xl bg-white/10 p-4 ring-1 ring-white/15 backdrop-blur">
              <FaShieldAlt className="text-xl text-[#4CA82F]" />
              <p className="mt-2 text-2xl font-bold">{sectionsCount}</p>
              <p className="text-xs text-white/70">fiches</p>
            </div>

            <div className="rounded-3xl bg-white/10 p-4 ring-1 ring-white/15 backdrop-blur">
              <FaQuestionCircle className="text-xl text-blue-300" />
              <p className="mt-2 text-2xl font-bold">10</p>
              <p className="text-xs text-white/70">questions</p>
            </div>

            <div className="rounded-3xl bg-white/10 p-4 ring-1 ring-white/15 backdrop-blur">
              <FaFlagCheckered className="text-xl text-amber-300" />
              <p className="mt-2 text-2xl font-bold">Mobile</p>
              <p className="text-xs text-white/70">optimisé</p>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}